export default 'dashboardPage';
